import { render, staticRenderFns } from "./CustomerServiceFloat.vue?vue&type=template&id=a0f0f544&scoped=true"
import script from "./CustomerServiceFloat.vue?vue&type=script&lang=js"
export * from "./CustomerServiceFloat.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceFloat.vue?vue&type=style&index=0&id=a0f0f544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f0f544",
  null
  
)

export default component.exports